import axios from "@/axios";

export const namespaced = true

export const state = {
    services: []
}

export const getters = {
        services: function (state) {
            return state.services;
        }
}

export const mutations = {
    GET_SERVICES: (state, response) => (state.services = response),
}
    

export const actions = {
        async getServices({commit}) {
            const results  =  await axios.get("/api/services")
            commit('GET_SERVICES',results.data.filter((service) => service.displayName != "PARTNER NATION"))
        }
}
